import React from "react";
import {Route, Switch} from "react-router-dom";
import DataEntrySideDrawer from "../components/DataEntry/DataEntrySideDrawer";
import HoldingsRouter from "../Assets/StandaloneAccount/HoldingsRouter";
import LegalAgreementHoldings from "../Assets/InvestmentProgram/LegalAgreementHoldings";
import PartiallyOwnedInvestmentAccountHoldings
    from "../Assets/PartiallyOwnedInvestment/EditPartiallyOwnedInvestment/PartiallyOwnedInvestmentAccountHoldings";
import HeldAwayAccountHoldings from "../Assets/InvestmentProgram/HeldAwayAccountHoldings";
import BankingAccountHoldings from "../Assets/BankingAccount/BankingAccountHoldings";
import AddOptionsAndGrants from "../Assets/EquityCompensation/AddOptionsAndGrants";

type DataEntrySideDrawerWrapperProps = {
    isOpen: boolean;
    type: "holdings" | "optionsAndGrant";
    viewType: string;
};

const DataEntrySideDrawerWrapper: React.FC<DataEntrySideDrawerWrapperProps> = ({isOpen, type, viewType}) => {
    if (type === "holdings") {
        return (
            <DataEntrySideDrawer isOpen={isOpen} size="full" formLayout="split"
                                 scrollableRegionId="holdings-side-drawer">
                <Switch>
                    <Route path={`/Profile/:profileId/ClientProfile/${viewType}/StandaloneAccount/:assetId/Holdings`}
                           component={HoldingsRouter}/>
                    <Route path={`/Profile/:profileId/ClientProfile/${viewType}/LegalAgreementHoldings/:assetId`}
                           component={LegalAgreementHoldings}/>
                    <Route
                           path={`/Profile/:profileId/ClientProfile/${viewType}/PartiallyOwnedInvestmentAccountHoldings/:assetId`}
                           component={PartiallyOwnedInvestmentAccountHoldings}/>
                    <Route path={`/Profile/:profileId/ClientProfile/${viewType}/HeldAwayAccountHoldings/:assetId`}
                           component={HeldAwayAccountHoldings}/>
                    <Route path={`/Profile/:profileId/ClientProfile/${viewType}/BankingAccount/:assetId/Holdings`}
                           component={BankingAccountHoldings}/>
                </Switch>
            </DataEntrySideDrawer>
        );
    }

    if (type === "optionsAndGrant") {
        return (
            <DataEntrySideDrawer size="full" formLayout="split" isOpen={isOpen}>
                <Switch>
                    <Route
                        path={`/Profile/:profileId/ClientProfile/${viewType}/EquityCompensation/:assetId/AddOptionsAndGrants`}
                        component={AddOptionsAndGrants}/>
                </Switch>
            </DataEntrySideDrawer>
        );
    }

    return null;
};

export default DataEntrySideDrawerWrapper;